<template>
  <div class="box12">
    <pageTitle
      title="双师伴学<br/>从学习到就业全程陪跑"
      text="技术导师+班主任，一站式搞定学习、练习、求职全流程"
      titleColor="#24375c"
      titColor="#86909C"
    />

    <div class="tab-bar">
      <div
        class="tab-bar__item"
        v-for="(item, index) in tabList"
        :key="index"
        :class="{
          'tab-bar__item--active': curTab === index,
          'tab-bar__item--teacher': index === 1,
        }"
        @click="curTab = index"
      >
        {{ item }}
      </div>
    </div>

    <div
      class="mentor-panel"
      :class="{ 'mentor-panel--teacher': curTab === 0 }"
    >
      <h3 class="mentor-panel__title">{{ panelTitle }}</h3>
      <div
        class="mentor-panel__badge"
        :class="{ 'mentor-panel__badge--teacher': curTab === 1 }"
      >
        {{ panelBadge }}
      </div>

      <div class="process-list">
        <div
          class="process-row"
          :class="{ 'process-row--teacher': curTab === 1 }"
          v-for="(item, index) in processList"
          :key="index"
        >
          <div class="process-row__stage">
            <span>{{ item.stage[0] }}</span>
            <span v-if="item.stage[1]">{{ item.stage[1] }}</span>
          </div>
          <img
            class="process-row__arrow"
            :src="
              curTab === 1
                ? require('../../../assets/coursePage/llm/box12/icon-arrow-blue.png')
                : require('../../../assets/coursePage/llm/box12/icon-arrow.png')
            "
            alt=""
          />
          <div class="process-row__content">
            <div class="process-row__tasks">
              <p v-for="(task, taskIndex) in item.tasks" :key="taskIndex">
                {{ task }}
              </p>
            </div>
            <img
              class="process-row__arrow"
              :src="
              curTab === 1
                ? require('../../../assets/coursePage/llm/box12/icon-arrow-blue.png')
                : require('../../../assets/coursePage/llm/box12/icon-arrow.png')
               "
              alt=""
            />
            <div
              class="process-row__outcome"
              :class="{ 'process-row__outcome--teacher': curTab === 1 }"
            >
              <p>{{ item.outcome[0] }}</p>
              <p>{{ item.outcome[1] }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="benefit-grid">
      <div
        class="benefit-card"
        v-for="(item, index) in benefitList"
        :key="index"
      >
        <img class="benefit-card__icon" :src="item.icon" alt="" />
        <div class="benefit-card__inner">
          <h4 class="benefit-card__title">{{ item.title }}</h4>
          <p class="benefit-card__text">
            <span>{{ item.line1 }}</span>
            <span>{{ item.line2 }}</span>
          </p>
        </div>
      </div>
    </div>

    <ConsultBtn text="1V1职业规划" />
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import ConsultBtn from "./ConsultBtn.vue";

export default {
  components: {
    pageTitle,
    ConsultBtn,
  },
  data() {
    return {
      curTab: 0,
      tabList: ["技术导师全程带教", "班主任全程伴学"],
      mentorProcessList: [
        {
          stage: ["入学起步", "阶段"],
          tasks: ["入学基础测评", "开发环境配置", "学习方向指引"],
          outcome: ["打好基础", "避免盲目起步"],
        },
        {
          stage: ["日常学习", "阶段"],
          tasks: ["串讲梳理重点", "及时解答疑问", "定期查漏补缺"],
          outcome: ["知识成体系", "基础够扎实"],
        },
        {
          stage: ["项目实训", "阶段"],
          tasks: ["项目实战指导", "攻坚疑难Bug", "优化项目亮点"],
          outcome: ["技术能落地", "简历有亮点"],
        },
        {
          stage: ["求职面试", "阶段"],
          tasks: ["打磨求职简历", "1V1模拟面试", "提升面试能力"],
          outcome: ["轻松过面试", "快速拿offer"],
        },
        {
          stage: ["就业护航", "阶段"],
          tasks: ["技术进阶指导", "职业规划建议", "分享工作经验"],
          outcome: ["入职上手快", "职场稳起步"],
        },
      ],
      teacherProcessList: [
        {
          stage: ["入班对接"],
          tasks: ["沟通学习基础", "讲解平台操作", "进专属学习群"],
          outcome: ["消除焦虑", "安心入学"],
        },
        {
          stage: ["学习规划"],
          tasks: ["每日学习安排", "明确学习目标", "灵活调整进度"],
          outcome: ["计划清晰", "节奏可控"],
        },
        {
          stage: ["全程督学"],
          tasks: ["监督学习进度", "班级群响应", "1V1心理疏导"],
          outcome: ["状态积极", "不掉队"],
        },
        {
          stage: ["考核管控"],
          tasks: ["跟进阶段测试", "检验学习成果", "确认阶段达标"],
          outcome: ["效果可见", "毕业无忧"],
        },
        {
          stage: ["就业跟进"],
          tasks: ["受理就业申请", "求职对接", "面试协助"],
          outcome: ["求职省心", "轻松拿offer"],
        },
      ],
      benefitList: [
        {
          title: "入行快",
          line1: "零基础快速入行",
          line2: "达到企业用人标准",
          icon: require("../../../assets/coursePage/llm/box12/icon-1.png"),
        },
        {
          title: "技能硬",
          line1: "技能+项目实战经验",
          line2: "面试通过率高",
          icon: require("../../../assets/coursePage/llm/box12/icon-2.png"),
        },
        {
          title: "offer稳",
          line1: "学习到就业全流程护航",
          line2: "拿offer更快",
          icon: require("../../../assets/coursePage/llm/box12/icon-3.png"),
        },
        {
          title: "成长顺",
          line1: "入职后技术答疑",
          line2: "职场稳步进阶",
          icon: require("../../../assets/coursePage/llm/box12/icon-4.png"),
        },
      ],
    };
  },
  computed: {
    panelTitle() {
      return this.curTab === 0 ? "技术导师全程带教" : "专属班主任全程伴学";
    },
    panelBadge() {
      return this.curTab === 0
        ? "从入学-学习-项目-求职-职场全周期护航"
        : "学员最靠谱的后盾，学习无后顾之忧";
    },
    processList() {
      return this.curTab === 0
        ? this.mentorProcessList
        : this.teacherProcessList;
    },
  },
};
</script>

<style lang="less" scoped>
.box12 {
  position: relative;
  padding: 80px 32px;
  width: 100%;
  box-sizing: border-box;
 
  background-color: #fff;

  /deep/ .course-title-box {
    position: relative;
    z-index: 1;
  }

  /deep/ .course-title {
    font-size: 48px;
    line-height: 68px;
    font-weight: 500;
  }

  /deep/ .course-text {
    font-size: 26px;
    line-height: 40px;
    margin-top: 14px;
  }

  .tab-bar {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    height: 80px;
    margin-top: 48px;
    padding: 6px;
    box-sizing: border-box;
    border-radius: 40px;
    background: #e9e9f2;
    box-shadow: inset 0 -2px 6px rgba(0, 0, 0, 0.03);

    &__item {
      flex: 1;
      height: 68px;
      border-radius: 34px;
      font-family: PingFangSC, PingFang SC;
      font-size: 28px;
      font-weight: 400;
      color: #4a6083;
      line-height: 68px;
      text-align: center;
      transition: all 0.2s;

      &--active {
        background: #ffffff;
        font-weight: 500;
        color: #0000e0;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

        &.tab-bar__item--teacher {
          color: #0660ff;
        }
      }
    }
  }

  .mentor-panel {
    position: relative;
    z-index: 1;
    margin-top: 32px;
    padding: 30px 30px 32px;
    box-sizing: border-box;
    background: linear-gradient(
      193deg,
      #fafcff 0%,
      rgba(234, 242, 255, 0.52) 46.08%,
      #d7e7ff 100%
    );
    border-radius: 32px;
    border: 2px solid #dae1ff;

    &--teacher {
      background: linear-gradient(193deg, #fefeff 0%, #f5f0ff 100%);
      border-radius: 32px;
      border: 2px solid #e2dfff;
    }

    &__title {
      margin: 0;
      font-family: PingFangSC, PingFang SC;
      font-size: 32px;
      font-weight: 700;
      color: #072557;
      line-height: 48px;
    }

    &__badge {
      display: inline-block;
      margin-top: 16px;
      padding: 0 20px;
      border-radius: 26px;
      background: #eeebff;
      font-family: PingFangSC, PingFang SC;
      font-size: 24px;
      font-weight: 400;
      color: #661fff;
      height: 52px;
      line-height: 52px;
      box-sizing:border-box;

      &--teacher {
        background: #e8f0ff;
        color: #065eff;
      }
    }
  }

  .process-list {
    margin-top: 32px;
  }

  .process-row {
    display: flex;
    align-items: center;
    min-height: 140px;
    margin-bottom: 12px;
   
    border-radius: 8px;
   
    &:last-child {
      margin-bottom: 0;
    }

    &--teacher {
      min-height: auto;
      padding: 0;
      background: transparent;
      box-shadow: none;
    }

    &__content {
      display: flex;
      align-items: center;
      jus
      flex: 1;
      min-width: 0;
      background: linear-gradient( 180deg, #FFFFFF 0%, rgba(255,255,255,0.43) 100%);
      box-shadow: 0px 0px 16px 0px #EFEAFB;
      border-radius: 20px;
      padding:16px 16px 16px 24px;
      justify-content: space-between;
      flex:1;
      .process-row--teacher & {
        padding: 8px 0;
        border-radius: 8px;
        background: linear-gradient(
          180deg,
          #ffffff 0%,
          rgba(255, 255, 255, 0.43) 100%
        );
        box-shadow: 0 0 18px rgba(239, 234, 251, 1);
      }
    }

    &__stage {
      flex-shrink: 0;
      width: 104px;
      text-align: center;
      font-family: PingFangSC, PingFang SC;
      font-size: 26px;
      font-weight: 500;
      color: #00245a;
      line-height: 38px;
    }

    &__arrow {
      flex-shrink: 0;
      width: 32px;
      height: 32px;
      object-fit: contain;
      margin:0 20px 0  16px;
    }

    &__tasks {
     
      min-width: 0;
      text-align: center;

      p {
        margin: 0;
        font-family: PingFangSC, PingFang SC;
        font-size: 24px;
        font-weight: 400;
        color: #606b7e;
        line-height: 36px;
      }
    }

    &__outcome {
      flex-shrink: 0;
      width: 190px;
      padding: 16px 12px;
      box-sizing: border-box;
      border-radius: 8px;
      background: linear-gradient(
        -135deg,
        #a55fff 0%,
        #375eff 69%,
        #065eff 100%
      );
      text-align: center;

      &--teacher {
        border-radius: 12px;
        background: linear-gradient(270deg, #00affe 0%, #065eff 100%);
      }

      p {
        margin: 0;
        font-family: PingFangSC, PingFang SC;
        font-size: 24px;
        font-weight: 500;
        color: #ffffff;
        line-height: 32px;
      }
    }
  }

  .benefit-grid {
    position: relative;
    z-index: 1;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 38px 30px;
    padding-top: 24px;
  }

  .benefit-card {
    position: relative;
    padding-top: 46px;

    &__icon {
      position: absolute;
      top: 0;
      left: 50%;
      z-index: 2;
      width: 92px;
      height: 92px;
      transform: translateX(-50%);
      object-fit: contain;
    }

    &__inner {
      min-height: 198px;
      padding: 44px 18px 24px;
      box-sizing: border-box;
      background: url("../../../assets/coursePage/llm/box12/benefit-card-bg.png")
        no-repeat center;
      background-size: 100% 100%;
      text-align: center;
    }

    &__title {
      margin: 0;
      font-family: PingFangSC, PingFang SC;
      font-size: 32px;
      font-weight: 700;
      color: #00245a;
      line-height: 52px;
    }

    &__text {
      margin: 8px 0 0;
      font-family: PingFangSC, PingFang SC;
      font-size: 26px;
      font-weight: 400;
      color: #00245a;
      line-height: 38px;

      span {
        display: block;
      }
    }
  }

}
</style>
